import { types as t } from 'mobx-state-tree';
import PropertyItem from "./PropertyItem";


const FacetValue = t.model("FacetValue", {
    Value: t.string,
    Count: t.number,
    Selected: t.optional(t.boolean, false),
    IsBooleanValue: t.optional(t.boolean, false),
    ColorCode: t.optional(t.string, ""),
    //UrlSlug: t.optional(t.string, ""),
    Guid: t.optional(t.string, ""),
    ParentGuid: t.maybeNull(t.string),
    Properties: t.optional(PropertyItem, {}),
    FacetValues: t.maybeNull(t.array(t.late(() => FacetValue))),
}).views(self => ({
    PropertyByKey(key) {
        const p = self.Properties[key];
        if (p) {
            return p;
        } else {
            return null;
        }
    },

})).actions(self => ({

}));


export default FacetValue;